import { React, useState } from "react";
import Ads from "./Ads";
import '../App.css'
import { useNavigate } from "react-router-dom";
import ReactPlayer from 'react-player'
import promoVideo from '../img/PromoVideo.mp4'




function Hero() {

  const navigate = useNavigate();
   const [showModal, setShowModal] = useState(false);
   const [playing, setPlaying] = useState(true);

  const handleClick = () => {
    navigate("/evaluacion/form");
}

  return (
    <div

    >
      <div className="wrapper bg-[#081730] flex items-center justify-between lg:px-[5rem] px-[2rem] rounded-b-[5rem] w-[100%] lg:h-[37rem] h-[40rem] lg:relative lg:z-[3] ">
        {/* left side */}
        <div className="headings flex flex-col lg:items-start justify-center h-[100%] lg:text-[3rem] text-[1.6rem] lg:mr-[50px]">
          <span className="lg:text-3xl text-2xl text-[#909090]">Educación Laboral</span>{" "}
         
          <span className="t-init">
          <b>Evaluación</b><em className="lg:font-size-smaller"> en Legislación Laboral y Recursos Humanos</em> 
          </span>
          <span className="block text-center mt-7 lg:mt-0 lg:text-[15px] text-[1rem] text-[#c5c5c5] lg:text-hero lg:content-start lg-description-position">
            <br className="lg:block hidden" />
            <p className="lg:t-init inline-block lg:block text-center lg:text-left">
            Ponga a prueba su conocimiento de las legislaciones laborales dominicanas y las mejores prácticas de Recursos Humanos.

          
            </p>
          </span>
          {/* download ads */}

          <div class="spacing lg:w-full lg:h-100px lg:flex ">
          <button class="h-14 lg:h-auto w-72 lg:w-72 bg-[#4A0094] hover:bg-[#643A90] text-white lg:text-lg font-bold lg:py-2 lg:px-4 border-b-4 border-[#643A90] hover:border-[#4A0094] rounded-full text-[18px] lg:text-initial" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" className="inline-flex h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
  <path d="M12 14l9-5-9-5-9 5 9 5z" />
  <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
<path strokeLinecap="round" strokeLinejoin="round" d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222" />
</svg> Comenzar 
</button>
 <button className="5xl:text-xl hidden lg:flex font-bold bg-white rounded-full shadow-lg w-[55px] border-4 border-l-[#311260] hover:border-[#311260] ml-4" onClick={()=>{setShowModal(true)}}><svg className="inline-flex self-center pl-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="black" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg></button>
                <p  className="text-sm font-bold pl-2 pt-2 lg:pt-0 self-center cursor-pointer hidden lg:flex" onClick={()=>{setShowModal(true)}}>Video Explicativo  {showModal ? (
        
          <div tabIndex={0} onBlur={(e)=>{e.preventDefault();setShowModal(false);setPlaying(false);}} className="flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-screen lg:w-full bg-transparent outline-none focus:outline-none">
              <button onClick={(e) => {setShowModal(false);  e.target.style.visibility = 'hidden';}} className='flex border-0 justify-end w-fit ml-auto bg-gray-500 rounded-full px-4 py-2 mb-2 font-bold text-2xl text-white hover:opacity-75 hover:bg-red-500'>
                x
               </button>
              <ReactPlayer
              controls
                playing={playing}
                 url={[
                  {src: promoVideo, type: 'video/mp4'},
                  
                    ]}
                />
               
              </div>
            </div>
          </div>
        
      ) : null}</p>
</div>
          <div>
            <span className="flex lg:text-[13px] text-[12px] text-hero">Conozca más de la plataforma de Educación Laboral</span>
            <div>
            <Ads />
            </div>
            
          </div>

       
         
        </div>
        {/* right side */}
        <div className="hidden w-[60%] relative lg:block content">
          {/* <motion.img
            variants={bg}
            animate={`${elementIsVisible}`}
            transition={{ duration: 1, type: "ease-out" }}
            src={require("../img/backgraphics.png")}
            alt=""
            className="absolute top-[-8rem] left-[19rem]"
          /> */}
          <img
            src={require("../img/educacion-laboral-academia-logo.png")}
            alt=""
            className="mb-[17rem]"
          />       
        </div>

      </div>
    </div>
  );
}

export default Hero;
